import { isApplicationEmbeded } from 'utils';

export default (topic, payload, targetOrigin = '*') => {
  if (topic && payload && isApplicationEmbeded()) {
    window.parent.postMessage({ topic, payload }, targetOrigin);
  }
};
